export default "__VITE_ASSET__BttP3VC5__"